<label
    class="mat-caption se-floating-label"
    [ngClass]="{ 'disabled': state === 'disabled', 'error': state === 'error', 'warning': state === 'warning' }"
    [for]="for"
    [title]="tooltip ?? ''"
>
    <ng-content></ng-content>
</label>
